/**
 * Global hayvan modu — StrayPaw.
 *
 * Kullanıcı header logosuna dokununca Kedi / Köpek-yakında / Hepsi seçer.
 * Seçim localStorage'da; v1 kedi odaklı olduğu için veri tarafında fark
 * yaratmaz, köpek verisi geldiğinde aynı anahtar API süzgecine bağlanacak.
 *
 * Değerler: "cats" | "dogs" | "all".  Varsayılan "cats" (StrayPaw v1 kedi odaklı).
 *
 * Backend `?animal` filtresi "cat" | "dog" bekler; `animalParam`
 * "all" → undefined (filtre yok) çevirir.
 */
const KEY = "sp_animal_mode";
const VALID = new Set(["cats", "dogs", "all"]);

export function getAnimalMode() {
  try {
    const v = localStorage.getItem(KEY);
    if (VALID.has(v)) return v;
  } catch {
    /* localStorage yoksa varsayılan */
  }
  return "cats";
}

export function setAnimalMode(mode) {
  const m = VALID.has(mode) ? mode : "cats";
  try {
    localStorage.setItem(KEY, m);
  } catch {
    /* yok say */
  }
  // Diğer bileşenler (liste/harita/şerit) taze veriyle yenilensin diye yayınla.
  try {
    window.dispatchEvent(new Event("sp-animal-mode"));
  } catch {
    /* SSR/test ortamı */
  }
  return m;
}

/** API çağrılarına eklenecek ?animal değeri. "all" → undefined (filtre yok). */
export function animalParam(mode) {
  const m = VALID.has(mode) ? mode : getAnimalMode();
  return m === "cats" ? "cat" : m === "dogs" ? "dog" : undefined;
}
